'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _CaretUpOutlined = _interopRequireDefault(require('./lib/icons/CaretUpOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _CaretUpOutlined;
exports.default = _default;
module.exports = _default;